// Contact page (Shopify Forms embed): set the market field to the current region
// and preselect the first option of "What foods are you dehydrating?".
(() => {
  const marketMap = {
    'benchfoodsdehydrators.com.au': 'au',
    'benchfoodsdehydrators.com': 'us',
    'benchfoodsdehydrators.co.uk': 'uk',
    'benchfoodsdehydrators.eu': 'eu',
    'benchfoodsdehydrators.co.nz': 'nz',
    'benchfoodsdehydrators.ca': 'ca'
  };

  const FOODS_LABEL = 'what foods are you dehydrating?';
  const processedForms = new WeakSet();

  const getMarketHandle = () => {
    const hostname = window.location.hostname.replace(/^www\./, '');
    return marketMap[hostname] ?? 'au';
  };

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();

  const setMarketField = (form) => {
    const marketField = form.elements['custom#market'];
    if (!marketField) return;

    marketField.value = getMarketHandle().toUpperCase();
    marketField.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    marketField.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    marketField.style.display = 'none';
    if (marketField.nextElementSibling) marketField.nextElementSibling.style.display = 'none';
  };

  const selectFirstFoodOption = (embed, form) => {
    // The label is not necessarily inside the dropdown's wrapper, so take the
    // first button/combobox that comes after the label in document order.
    const label = [...form.querySelectorAll('*')].find((element) =>
      element.children.length === 0 &&
      normalize(element.textContent || '').toLowerCase() === FOODS_LABEL
    );
    if (!label) return;

    const selectorButton = [...form.querySelectorAll('button, [role="combobox"]')].find((element) =>
      label.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING
    );
    if (!selectorButton) return;

    const selectOption = () => {
      const listboxId = selectorButton.getAttribute('aria-controls');
      const listbox = listboxId
        ? embed.shadowRoot.getElementById(listboxId)
        : embed.shadowRoot.querySelector('[role="listbox"]');
      if (!listbox) return false;

      const option = listbox.querySelector('[role="option"]');
      if (!option) return false;
      option.click();
      return true;
    };

    if (selectorButton.getAttribute('aria-expanded') !== 'true') {
      selectorButton.click();
    }

    // The options are mounted only after the selector is opened.
    if (!selectOption()) {
      const optionObserver = new MutationObserver(() => {
        if (selectOption()) optionObserver.disconnect();
      });
      optionObserver.observe(embed.shadowRoot, { childList: true, subtree: true });
      setTimeout(() => optionObserver.disconnect(), 2000);
    }
  };

  const updateContactForm = (embed) => {
    const form = embed.shadowRoot?.querySelector('form');
    // The form renders asynchronously; retry until it exists.
    if (!form || !form.elements['custom#market']) {
      setTimeout(() => updateContactForm(embed), 250);
      return;
    }
    if (processedForms.has(form)) return;
    processedForms.add(form);

    setMarketField(form);
    selectFirstFoodOption(embed, form);
  };

  const observedEmbeds = new WeakSet();

  const observeEmbed = (embed) => {
    if (observedEmbeds.has(embed)) return;

    if (!embed.shadowRoot) {
      setTimeout(() => observeEmbed(embed), 250);
      return;
    }
    observedEmbeds.add(embed);
    updateContactForm(embed);
  };

  const scanForEmbeds = () => {
    document.querySelectorAll('shopify-forms-embed').forEach(observeEmbed);
  };

  const init = () => {
    scanForEmbeds();
    new MutationObserver(scanForEmbeds).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
